webpackJsonp([102],{

/***/ "/Okj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hasPermission; });
var allAsideNav = [{
  path: '/home',
  name: '首頁',
  icon: 'el-icon-location',
  roles: ['admin', 'visitor', 'esg.admin', 'editor']
}, {
  path: 'mgsys',
  name: '心願認養',
  icon: 'el-icon-star-on',
  roles: ['admin', 'visitor', 'esg.admin'],
  children: [{
    path: '/wishMg',
    name: '心願管理',
    roles: ['admin', 'visitor', 'esg.admin']
  }, {
    path: '/readingMg',
    name: '愛閱分享',
    roles: ['admin', 'visitor']
  }, {
    path: '/wishConfig',
    name: '心願配置',
    roles: ['admin', 'visitor', 'esg.admin']
  }]
}, {
  path: 'auditMg',
  name: '審核管理',
  icon: 'el-icon-service',
  roles: ['admin', 'visitor'],
  children: [{
    path: '/changeRoleMg',
    name: '身份轉換'
  }, {
    path: '/realNameMg',
    name: '實名認證'
  }, {
    path: '/reportedGifts',
    name: '被檢舉禮物審核'
  }, {
    path: '/reportedNeeds',
    name: '被檢舉需求審核'
  }, {
    path: '/reportedMoments',
    name: '被檢舉說說審核'
  }, {
    path: '/newconnect',
    name: '交接預告審核'
  }, {
    path: '/applyCancelDeals',
    name: '取消交易申請'
  }, {
    path: '/userMarks',
    name: '黑名單管理'
  }, {
    path: '/giftRatings',
    name: '物況反饋審核'
  }]
}, {
  path: 'users',
  name: '使用者管理',
  iconAws: 'user-circle-o',
  roles: ['admin', 'visitor'],
  children: [{
    path: '/users',
    name: '使用者列表'
  }, {
    path: '/userLogins',
    name: '登入記錄'
  }, {
    path: '/userBonus',
    name: '好人點預警'
  }, {
    path: '/multipleAccounts',
    name: '分身監控'
  }]
}, {
  path: 'gifts',
  name: '禮物管理',
  icon: 'el-icon-goods',
  roles: ['admin', 'visitor'],
  children: [{
    path: '/gifts',
    name: '禮物池'
  }, {
    path: '/giftRecords',
    name: '禮物交易記錄'
  }]
}, {
  path: 'needs',
  name: '需求管理',
  iconAws: 'shopping-cart',
  roles: ['admin', 'visitor'],
  children: [{
    path: '/needsListMg',
    name: '需求池'
  }, {
    path: '/needsRecords',
    name: '需求交易記錄'
  }, {
    path: '/needsSections',
    name: '需求專區管理'
  }]
}, {
  path: 'moments',
  name: '說說管理',
  iconAws: 'comment-o',
  roles: ['admin', 'visitor', 'editor'],
  children: [{
    path: '/momentsListMg',
    name: '說說列表'
  }]
}, {
  path: 'regardItem',
  name: '心意牆',
  iconAws: 'heart',
  roles: ['admin', 'visitor'],
  children: [{
    path: '/regardItem/list',
    name: '贊助方案',
    roles: ['admin']
  }, {
    path: '/regardItem/sponsors',
    name: '贊助列表',
    roles: ['admin']
  }, {
    path: '/regardItem/greetings',
    name: '祝福列表',
    roles: ['admin']
  }]
}, {
  path: 'setting',
  name: '平台管理',
  iconAws: 'cog',
  roles: ['admin', 'visitor', 'editor', 'esg.admin', 'love.admin'],
  children: [{
    path: '/cabinetGiftMg',
    name: '好禮公告管理',
    roles: ['admin', 'visitor']
  }, {
    path: '/bannerMg',
    name: 'Banner管理',
    roles: ['admin', 'visitor', 'editor', 'esg.admin']
  }, {
    path: '/preEvents',
    name: '預約活動管理',
    roles: ['admin', 'visitor', 'editor']
  }, {
    path: '/stories',
    name: '故事文章管理',
    roles: ['admin', 'visitor', 'editor', 'esg.admin']
  }, {
    path: '/edmMg',
    name: 'EDM管理',
    roles: ['admin', 'visitor', 'editor']
  }, {
    path: '/notifyMg',
    name: '通知管理',
    roles: ['admin', 'visitor', 'editor', 'love.admin']
  }, {
    path: '/feedBackMg',
    name: '用戶反饋管理',
    roles: ['admin', 'visitor']
  }, {
    path: '/changeLogMg',
    name: '更新日志管理',
    roles: ['admin']
  }, {
    path: '/agreementConfig',
    name: '使用者條款',
    roles: ['admin', 'visitor', 'editor']
  }, {
    path: '/privacyConfig',
    name: '隱私權政策',
    roles: ['admin', 'visitor', 'editor']
  }, {
    path: '/carbonAccountAgreementConfig',
    name: 'GC減碳帳戶使用者條款',
    roles: ['admin', 'visitor', 'editor']
  }, {
    path: '/about543Config',
    name: '認識我們',
    roles: ['admin', 'visitor', 'editor']
  }, {
    path: '/settings',
    name: '平台設置',
    roles: ['admin']
  }, {
    path: '/welfare/enterprises',
    name: '社福互動獎-響應企業',
    roles: ['admin']
  }]
}, {
  path: 'wallet',
  name: '金流管理',
  icon: 'el-icon-money',
  roles: ['visitor'],
  children: [{
    path: '/wallet/paymentOrders',
    name: '儲值記錄'
  }, {
    path: '/wallet/paymentStatistics',
    name: '金額統計'
  }, {
    path: '/wallet/walletRecords',
    name: '會員錢包記錄'
  }, {
    path: '/wallet/walletRecordsStatistics',
    name: '蘿蔔點數使用統計'
  }, {
    path: '/wallet/walletUserStatistics',
    name: '會計月結表'
  }, {
    path: '/wallet/iboxOrders',
    name: 'i郵箱訂單'
  }, {
    path: '/wallet/hctOrders',
    name: '月結新竹訂單'
  }, {
    path: '/wallet/hilifeOrders',
    name: '萊爾富訂單'
  }, {
    path: '/wallet/sevenElevenOrders',
    name: '7-11訂單'
  }, {
    path: '/wallet/refunds',
    name: '退點記錄'
  }, {
    path: '/wallet/coupons',
    name: '抵用券'
  }, {
    path: '/wallet/couponRecords',
    name: '抵用券記錄'
  }]
}, {
  path: 'lovebox',
  name: '代贈版',
  iconAws: 'cube',
  roles: ['admin', 'visitor', 'love.admin', 'esg.admin'],
  children: [{
    path: '/lovebox/application',
    name: '合作意向管理'
  }, {
    path: '/lovebox/companies-apply',
    name: '申請管理'
  }, {
    path: '/lovebox/companies',
    name: '共享圈(停用)'
  }, {
    path: '/lovebox/objects',
    name: '物品管理'
  }, {
    path: '/lovebox/trades',
    name: '交易管理'
  }, {
    path: '/lovebox/dispatching',
    name: '愛箱寄送記錄'
  }, {
    path: '/lovebox/whitelist',
    name: '白名單管理'
  }, {
    path: '/lovebox/courseNotifyMg',
    name: '教練課通知管理'
  }]
}, {
  path: 'organization',
  name: 'GC Group',
  iconAws: 'sitemap',
  roles: ['visitor', 'esg.admin'],
  children: [{
    path: '/carbonlabelling/organizers',
    name: '聯合團隊'
  }, {
    path: '/carbonlabelling/groups',
    name: 'Group'
  }, {
    path: '/carbonlabelling/users',
    name: 'Group成員列表'
  },
  // {
  //   path: '/carbonlabelling/courses',
  //   name: '課程管理'
  // },
  // {
  //   path: '/carbonlabelling/subscriptions',
  //   name: '團隊授權'
  // },
  // {
  //   path: '/carbonlabelling/course-results',
  //   name: '學習數據'
  // },
  {
    path: '/organizers',
    name: '共享圈(停用)'
  }, {
    path: '/organizers/users',
    name: '共享圈成員列表(停用)'
  }, {
    path: '/companyPages',
    name: '形象頁(停用)'
  }]
}, {
  path: 'carbon-account',
  name: 'GC Pro',
  iconAws: 'leaf',
  roles: ['visitor', 'esg.admin'],
  children: [{
    path: '/carbon-account/products',
    name: '方案管理'
  }, {
    path: '/carbon-account/orders',
    name: '訂單管理'
  }, {
    path: '/carbon-account/discounts',
    name: '折扣碼管理'
  }, {
    path: '/carbon-account/discount-records',
    name: '折扣碼使用記錄'
  }, {
    path: '/carbon-account/contacts',
    name: '聯絡'
  }]
}, {
  path: 'express',
  name: '分享通管理',
  iconAws: 'truck',
  roles: ['visitor'],
  children: [{
    path: '/expresses',
    name: '寄件訂單'
  }]
}];

var hasPermission = function hasPermission(roles, nav) {
  if (nav && nav.roles) {
    return roles.some(function (role) {
      return nav.roles.indexOf(role) >= 0;
    });
  } else {
    return true;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (allAsideNav);

/***/ }),

/***/ "07PK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router_asideNav_js__ = __webpack_require__("/Okj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__("FlIN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      smartImagePath: __WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* smartImagePath */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapState */])({
    userInfo: function userInfo(state) {
      return state.user.userInfo;
    }
  }), {
    roles: function roles() {
      return this.userInfo && this.userInfo.roles ? this.userInfo.roles : [];
    },
    asideNav: function asideNav() {
      var _this = this;

      if (!this.roles || !this.roles.length) {
        return [];
      }

      return __WEBPACK_IMPORTED_MODULE_1__router_asideNav_js__["a" /* default */].filter(function (item) {
        if (_this.roles.includes('admin')) {
          return true;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_1__router_asideNav_js__["b" /* hasPermission */])(_this.roles, item)) {
          if (item.children) {
            item.children = item.children.filter(function (child) {
              if (_this.roles.includes('admin')) {
                return true;
              }

              if (Object(__WEBPACK_IMPORTED_MODULE_1__router_asideNav_js__["b" /* hasPermission */])(_this.roles, child)) {
                return true;
              }

              return false;
            });
          }
          return true;
        }

        return false;
      });
    }
  }),
  methods: {
    handleOpen: function handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose: function handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    logout: function logout() {
      this.$store.commit('LOGOUT');
      window.open('/login', '_self');
      // this.$router.replace(`/login?${this.$route.fullPath}`)
    }
  }
});

/***/ }),

/***/ "1gIA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//

var TAG_META = {
  pro: { text: 'P', label: 'Pro 會員', className: 'tag-badge--pro' },
  group: { text: 'G', label: 'Group 成員（碳標籤團隊）', className: 'tag-badge--group' }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UserTags',
  props: {
    tags: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    showTags: function showTags() {
      return (this.tags || []).filter(function (tag) {
        return TAG_META[tag];
      }).map(function (tag) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ key: tag }, TAG_META[tag]);
      });
    }
  }
});

/***/ }),

/***/ "5Xbg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5reh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PRE_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NEXT_PAGE; });
// LOGIN MODULE
var LOGIN = 'LOGIN';

var LOGOUT = 'LOGOUT';

var PRE_PAGE = 'PRE_PAGE';

var NEXT_PAGE = 'NEXT_PAGE';

/***/ }),

/***/ "8e4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return wishStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return wishNoOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return userIdOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return userRestrictionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return userLastLoginOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return wishTimeOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return valuation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return idStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return verifyStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return loginTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return roleList; });
/* unused harmony export careInfo */
/* unused harmony export publicGroups */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return storyTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return hintMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return ckeditorConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return needStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return thingCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return loveboxTradeStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return needShipWays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return needDealStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return giftDealStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return edmStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return chlgTagType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return fbackType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOVEBOX_ITEM_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return loveboxItemStatuses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return loginError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return fbStatusList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_WISH_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return showOptions; });
/* unused harmony export PAY_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PAY_TYPE_TEXTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PAY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PAY_STATUS_TEXTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return WALLET_RECORD_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return WALLET_DEAL_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return WALLET_DEAL_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PURCHASE_FROM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return REFUND_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return REFUND_TEXTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return USER_RESTRICTION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EXPRESS_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EXPRESS_STATUS_TXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COUPON_RECORD_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COUPON_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COUPON_VALID_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return WISH_ORGANIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COUPON_SCENE; });
/* unused harmony export ORGANIZER_STATUS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ORGANIZER_STATUS_TXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return STORY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LOVE_ORDER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOVE_BOX_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOVE_ORDER_STATUS_TXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOVE_BOX_STATUS_TXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return RECYCLE_ID_ORDER_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return RECYCLE_ID_ORDER_STATUS_TXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return RECYCLE_ID_DISCOUNT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return RECYCLE_ID_DISCOUNT_TYPE_TXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RECYCLE_ID_DISCOUNT_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RECYCLE_ID_DISCOUNT_STATUS_TXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RECYCLE_ID_DISCOUNT_RECORD_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RECYCLE_ID_DISCOUNT_RECORD_STATUS_TXT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _PAY_TYPE_TEXTS, _PAY_STATUS_TEXTS, _WALLET_DEAL_TEXT, _REFUND_TEXTS, _EXPRESS_STATUS_TXT, _ORGANIZER_STATUS_TXT, _LOVE_ORDER_STATUS_TX, _LOVE_BOX_STATUS_TXT, _RECYCLE_ID_ORDER_STA, _RECYCLE_ID_DISCOUNT_, _RECYCLE_ID_DISCOUNT_2, _RECYCLE_ID_DISCOUNT_3;

// import { uploadUrl } from './config'

var wishStatus = [{
  label: '所有',
  value: ''
}, {
  label: '未認養',
  value: 'on'
}, {
  label: '已認養',
  value: 'end'
}, {
  label: '認養已送達',
  value: 'done'
}];

var wishNoOrder = [{
  label: '升序',
  value: 'wish_no_asc',
  id: 1
}, {
  label: '降序',
  value: 'wish_no_desc',
  id: 2
}];

var userIdOrder = [{ label: '升序', value: 'sort_id_asc' }, { label: '降序', value: 'sort_id_desc' }];

var userRestrictionTypes = [{ label: '所有', value: '' }, { label: '停權', value: 'DISABLE' }, { label: '調查中', value: 'INVESTIGATE' }, { label: 'GC代贈停權', value: 'DISABLE_LOVE' }, { label: '閃送停權', value: 'LIMIT_PUBLISH_FLASH' }];

var userLastLoginOrder = [{ label: '升序', value: 'sort_last_login_asc' }, { label: '降序', value: 'sort_last_login_desc' }];

var wishTimeOrder = [{
  label: '升序',
  value: 'updated_at_asc',
  id: 1
}, {
  label: '降序',
  value: 'updated_at_desc',
  id: 2
}];

var valuation = [{
  text: '0~500元',
  value: 0
}, {
  text: '500~1000元',
  value: 500
}, {
  text: '1000~5000元',
  value: 1000
}, {
  text: '5000~10000元',
  value: 5000
}, {
  text: '10000~50000元',
  value: 10000
}, {
  text: '50000元以上',
  value: 50000
}];

// 实名验证常量
var idStatus = [{
  label: '所有'
}, {
  label: '未驗證'
}, {
  label: '已驗證'
}, {
  label: '驗證失敗'
}];

// 会员变更身份常量
var verifyStatus = [{
  label: '所有'
}, {
  label: '未審核'
}, {
  label: '未通過'
}, {
  label: '通過'
}];

// 登入方式
var loginTypes = [{ label: '手機', value: 'PHONE' }, { label: '電子郵件', value: 'EMAIL' }, { label: 'GOOGLE', value: 'GOOGLE' }, { label: 'FACEBOOK', value: 'FACEBOOK' }];

// 后端已提供该接口，暂时不从这里拿数据，commonConfig mixin
var roleList = [{
  label: '一般會員',
  value: 'normal',
  id: 36
}, {
  label: '關懷會員',
  value: 'care',
  id: 31
}, {
  label: '公益團體',
  value: 'commonweal',
  id: 32
}, {
  label: '學校單位',
  value: 'school',
  id: 34
}, {
  label: '政府機關',
  value: 'gov',
  id: 35
}, {
  label: '企業行號',
  value: 'company',
  id: 33
}, {
  label: '官方帳號',
  value: 'official',
  id: 51
}, {
  label: 'GC循環站',
  value: 'gccycle',
  id: 52
}];

// 关怀会员相关
var careInfo = [{
  label: '低收入戶'
}, {
  label: '中收入戶'
}, {
  label: '殘障手冊'
}, {
  label: '其他'
}];

var publicGroups = [{
  label: '財團法人'
}, {
  label: '社團法人'
}, {
  label: '人民團體'
}, {
  label: '其他'
}];

var storyTypes = [{ 'id': 21, 'title': '公告消息' }, { 'id': 22, 'title': '企業合作' }, { 'id': 23, 'title': '公益合作' }, { 'id': 24, 'title': '公益走訪/地圖' }, { 'id': 25, 'title': '公益迴響' }, { 'id': 26, 'title': '募集滿額' }, { 'id': 27, 'title': '名人分享' }, { 'id': 28, 'title': '公益捐款' }, { 'id': 37, 'title': '媒體報導' }];

var hintMsg = {
  loadingText: '玩命加載中...',
  serverErrorMsg: '出錯咯！～請聯繫管理員'
};

var ckeditorConfig = {
  toolbarGroups: [{ name: 'document', groups: ['mode', 'document', 'doctools'] }, { name: 'clipboard', groups: ['clipboard', 'undo'] }, { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] }, { name: 'forms', groups: ['forms'] }, { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] }, { name: 'tools', groups: ['tools'] }, { name: 'links', groups: ['links'] }, { name: 'colors', groups: ['colors'] }, { name: 'insert', groups: ['insert'] }, '/', { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] }, { name: 'styles', groups: ['styles'] }, { name: 'others', groups: ['others'] }, { name: 'about', groups: ['about'] }],
  removeButtons: 'Save,NewPage,Preview,Print,Templates,Cut,Copy,PasteText,Find,Replace,SelectAll,Scayt,Checkbox,Radio,Iframe,TextField,Textarea,Select,Button,ImageButton,HiddenField,Form,Language,Unlink,Flash,SpecialChar,About,ShowBlocks,CreateDiv,Blockquote,PageBreak',
  height: 500,
  extraPlugins: 'youtube',
  pasteFromWordRemoveFontStyles: false,
  pasteFromWordRemoveStyles: false,
  allowedContent: true,
  disallowedContent: 'script; *[on*]'
};

var needStatus = [{
  label: '所有',
  value: '',
  className: ''
}, {
  label: '進行中',
  value: 'ongoing',
  className: 'color-green'
}, {
  label: '未開始',
  value: 'pending',
  className: ''
}, {
  label: '已結案',
  value: 'finish',
  className: 'color-red'
}, {
  label: '已下架',
  value: 'pull_off',
  className: 'color-gray'
}];

var thingCategory = [{ value: 1, label: '女裝、女用品' }, { value: 49, label: '化妝品、保養品' }, { value: 2, label: '男裝、男用品' }, { value: 3, label: '圖書、文具、影音' }, { value: 4, label: '婦幼、童裝、嬰幼' }, { value: 5, label: '運動、戶外、休閒' }, { value: 6, label: '居家、餐廚' }, { value: 7, label: '食品、飲料' }, { value: 8, label: '家電、視聽' }, { value: 9, label: '手機、配件' }, { value: 10, label: '日用、清潔' }, { value: 11, label: '汽機車周邊' }, { value: 12, label: '玩具、收藏' }, { value: 13, label: '電腦、周邊' }, { value: 14, label: '教學、人力' }, { value: 15, label: '相機、攝影' }, { value: 16, label: '票券、點數' }, { value: 17, label: '電玩相關' }, { value: 18, label: '寵物相關' }, { value: 19, label: '家具' }, { value: 20, label: '其它' }];

var loveboxTradeStatuses = [{ value: 0, label: '已創建' }, { value: 1, label: '已寄送' }, { value: 2, label: '交易完成' }, { value: 3, label: '已感謝' }];

var needShipWays = [{
  label: '所有',
  value: ''
}, {
  label: '萊爾富',
  value: 'hilife'
}, {
  label: '7-11交貨便',
  value: 'seven_eleven'
}, {
  label: '全家店到店',
  value: 'fami'
}, {
  label: '新竹物流',
  value: 'hct'
}, {
  label: '其他物流',
  value: 'others'
}, {
  label: '面交',
  value: 'meet'
}, {
  label: '賀盟物流',
  value: 'homeng'
}, {
  label: '掌櫃',
  value: 'palmbox'
}, {
  label: 'ｉ郵箱',
  value: 'ibox'
}, {
  label: '直購',
  value: 'direct_purchase'
}];

var needDealStatus = [{
  label: '所有',
  value: ''
}, {
  label: '索取中',
  value: 'init'
}, {
  label: '婉拒',
  value: 'pass'
}, {
  label: '匯款中',
  value: 'remitting'
}, {
  label: '已匯款',
  value: 'remitted'
}, {
  label: '等待寄送',
  value: 'received_money'
}, {
  label: '已寄送',
  value: 'sent'
}, {
  label: '取消贈送',
  value: 'cancel'
}, {
  label: '完成',
  value: 'finished'
}, {
  label: '已感謝',
  value: 'thanks'
}, {
  label: '確認運送細節',
  value: 'comfirm_ship'
}, {
  label: '未記錄',
  value: null
}];

var giftDealStatus = [{ value: 'requesting', label: '索取中' }, { value: 'pass', label: '婉拒' }, { value: 'remitting', label: '匯款中' }, { value: 'remitted', label: '已匯款' }, { value: 'received_money', label: '等待寄送' }, { value: 'sent', label: '已寄送' }, { value: 'cancel', label: '取消贈送' }, { value: 'finished', label: '完成' }, { value: 'thanks', label: '已感謝' }, { value: 'not_obtained', label: '未獲贈' }];

var edmStatus = [{ value: 0, label: '已失效', className: 'color-gray' }, { value: 1, label: '有效', className: 'color-main' }, { value: 2, label: '发送中', className: 'color-golden' }, { value: 3, label: '已发送', className: 'color-green' }];

var chlgTagType = [{ value: '優化', label: '優化' }, { value: '功能', label: '功能' }, { value: '修復', label: '修復' }];

var fbackType = [{
  value: '使用問題回報',
  label: '使用問題回報'
}, {
  value: '操作流程諮詢',
  label: '操作流程諮詢'
}, {
  value: '違規行為檢舉',
  label: '違規行為檢舉'
}, {
  value: '使用回饋建議',
  label: '使用回饋建議'
}, {
  value: '平台合作提案',
  label: '平台合作提案'
}, {
  value: '其他',
  label: '其他'
}];

// export const fbackStatus = [
//   {
//     label: '所有',
//     value: ''
//   }, {
//     label: '未處理',
//     value: 0
//   }, {
//     label: '已處理',
//     value: 1
//   }
// ]

var LOVEBOX_ITEM_STATUS = {
  STATUS_DELETED: 0,
  STATUS_ON_SHELVE: 1,
  STATUS_OFF_SHELVE: 2,
  STATUS_FINISH: 3,
  STATUS_HIDDEN: 4
};

var loveboxItemStatuses = [{
  label: '已删除',
  value: 0
}, {
  label: '進行中',
  value: 1
}, {
  label: '已下架',
  value: 2
}, {
  label: '已完成',
  value: 3
}, {
  label: '待上架',
  value: 4
}];

var loginError = {
  205: '密碼錯誤請重試！',
  201: '賬戶不存在',
  202: '沒有權限',
  'other': '登入錯誤，賬戶不存在或無權限，如有問題請聯系管理員'
};

var fbStatusList = [{
  value: 0,
  label: '未查看'
}, {
  value: 1,
  label: '已查看'
}, {
  value: 2,
  label: '已處理'
}];

var BASE_WISH_YEAR = 2016;

var showOptions = [{
  value: 1,
  label: '不展示隱藏'
}, {
  value: 2,
  label: '只展示隱藏'
}, {
  value: 3,
  label: '展示全部'
}];

var PAY_TYPE = {
  CREDIT_CARD: '01', // 信用卡
  VIRTUAL_ACCOUNT: '03',
  GREEN_POINT: 'greenpoint'
};

var PAY_TYPE_TEXTS = (_PAY_TYPE_TEXTS = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAY_TYPE_TEXTS, PAY_TYPE.CREDIT_CARD, '信用卡'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAY_TYPE_TEXTS, PAY_TYPE.VIRTUAL_ACCOUNT, 'ATM 虛擬帳號'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAY_TYPE_TEXTS, PAY_TYPE.GREEN_POINT, '綠點兌換'), _PAY_TYPE_TEXTS);

var PAY_STATUS = {
  INVALID: -1,
  CANCEL: 0,
  CHARGING: 1,
  CHARGED: 2
};

var PAY_STATUS_TEXTS = (_PAY_STATUS_TEXTS = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAY_STATUS_TEXTS, PAY_STATUS.CANCEL, '已過期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAY_STATUS_TEXTS, PAY_STATUS.CHARGING, '待付款'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAY_STATUS_TEXTS, PAY_STATUS.CHARGED, '儲值完成'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_PAY_STATUS_TEXTS, PAY_STATUS.INVALID, '下單失敗'), _PAY_STATUS_TEXTS);

var WALLET_RECORD_TYPES = {
  CHARGE: 1,
  CONSUME: 2,
  REFUND: 3,
  REWARD: 4,
  RETURN: 5,
  EXCHANGE: 6,
  DEPOSIT_RETURN: 7, // 押金退回
  EXPIRE: 8 // 限時點數到期歸零
};

var WALLET_DEAL_TYPES = {
  CHARGE: 1,
  GIFT_REQUEST: 2,
  NEED_DONATE: 3,
  SPONSOR: 4,
  LOVE_ORDER: 6,
  EXPRESS: 7,
  FREIGHT_DONATE: 8,
  GC_REWARD: 9
};

var WALLET_DEAL_TEXT = (_WALLET_DEAL_TEXT = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WALLET_DEAL_TEXT, WALLET_DEAL_TYPES.GIFT_REQUEST, '禮物索取'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WALLET_DEAL_TEXT, WALLET_DEAL_TYPES.NEED_DONATE, '需求贈送'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WALLET_DEAL_TEXT, WALLET_DEAL_TYPES.SPONSOR, '心意牆贊助'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WALLET_DEAL_TEXT, WALLET_DEAL_TYPES.LOVE_ORDER, 'GC代贈'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_WALLET_DEAL_TEXT, WALLET_DEAL_TYPES.EXPRESS, '分享通'), _WALLET_DEAL_TEXT);

var PURCHASE_FROM = [{ label: '用戶提供', value: 0 }, { label: 'momo直購', value: 1 }];

var REFUND_STATUS = {
  PENDING: 1,
  EXECUTED: 2,
  INVALID: 0
};

var REFUND_TEXTS = (_REFUND_TEXTS = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_REFUND_TEXTS, REFUND_STATUS.PENDING, '待退點'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_REFUND_TEXTS, REFUND_STATUS.EXECUTED, '已退點'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_REFUND_TEXTS, REFUND_STATUS.INVALID, '已失效'), _REFUND_TEXTS);

var USER_RESTRICTION_TYPE = {
  DISABLE: '停權',
  INVESTIGATE: '調查中',
  DISABLE_LOVE: 'GC代贈停權',
  LIMIT_MOMENT: '限制發文中'
};

var EXPRESS_STATUS = {
  INIT: 'init', // 待完善寄件信息等
  UNPAID: 'unpaid', // 待付運費
  PAID: 'paid',
  SENT: 'sent',
  DONE: 'done',
  CANCELLED: 'cancelled'
};

var EXPRESS_STATUS_TXT = (_EXPRESS_STATUS_TXT = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EXPRESS_STATUS_TXT, EXPRESS_STATUS.INIT, '待填寫收件資料'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EXPRESS_STATUS_TXT, EXPRESS_STATUS.UNPAID, '待付運費'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EXPRESS_STATUS_TXT, EXPRESS_STATUS.PAID, '待寄出'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EXPRESS_STATUS_TXT, EXPRESS_STATUS.SENT, '待收件'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EXPRESS_STATUS_TXT, EXPRESS_STATUS.DONE, '已完成'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EXPRESS_STATUS_TXT, EXPRESS_STATUS.CANCELLED, '已取消'), _EXPRESS_STATUS_TXT);

var COUPON_RECORD_STATUS = {
  VALID: 0,
  USED: 1,
  EXPIRED: 2,
  FROZEN: 3
};

var COUPON_TYPE = {
  NO_THRESHOLD: 0,
  DISCOUNT: 1
};

var COUPON_VALID_TYPE = {
  TIME: 1,
  DAYS: 2
};

var WISH_ORGANIZER = {
  KUENTAI: 1,
  VIS: 2,
  WPG: 3,
  MAKALOT: 4,
  MEDIATEK: 5
};

var COUPON_SCENE = {
  ALL: 0, // 通用場景
  FLASH: 1, // 閃送區專用
  LOVEBOX: 2 // GC代贈索取
};

var ORGANIZER_STATUS = {
  RUNNING: 0,
  LIMIT: 1,
  CLOSE: 2
};

var ORGANIZER_STATUS_TXT = (_ORGANIZER_STATUS_TXT = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ORGANIZER_STATUS_TXT, ORGANIZER_STATUS.RUNNING, ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ORGANIZER_STATUS_TXT, ORGANIZER_STATUS.LIMIT, '限制中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ORGANIZER_STATUS_TXT, ORGANIZER_STATUS.CLOSE, '已關閉'), _ORGANIZER_STATUS_TXT);

var STORY_STATUS = {
  DELETE: -1, // 已刪除
  HIDE: 0, // 預上線
  SHOW: 1, // 上架
  OFF: 2 // 下架
};

var LOVE_ORDER_STATUS = {
  STATUS_CANCEL: -1,
  STATUS_INIT: 0,
  STATUS_UNPAID: 1,
  STATUS_PAID: 2,
  STATUS_SENT: 3,
  STATUS_RECEIVED: 4,
  STATUS_DONE: 5
};

var LOVE_BOX_STATUS = {
  STATUS_INIT: 0,
  STATUS_SENT: 1,
  STATUS_RECEIVED: 2
};

var LOVE_ORDER_STATUS_TXT = (_LOVE_ORDER_STATUS_TX = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOVE_ORDER_STATUS_TX, LOVE_ORDER_STATUS.STATUS_INIT, '揀貨中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOVE_ORDER_STATUS_TX, LOVE_ORDER_STATUS.STATUS_UNPAID, '待付運費'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOVE_ORDER_STATUS_TX, LOVE_ORDER_STATUS.STATUS_PAID, '揀貨中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOVE_ORDER_STATUS_TX, LOVE_ORDER_STATUS.STATUS_SENT, '已寄出'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOVE_ORDER_STATUS_TX, LOVE_ORDER_STATUS.STATUS_RECEIVED, '已送達'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOVE_ORDER_STATUS_TX, LOVE_ORDER_STATUS.STATUS_DONE, '已完成'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOVE_ORDER_STATUS_TX, LOVE_ORDER_STATUS.STATUS_CANCEL, '已取消'), _LOVE_ORDER_STATUS_TX);

var LOVE_BOX_STATUS_TXT = (_LOVE_BOX_STATUS_TXT = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOVE_BOX_STATUS_TXT, LOVE_BOX_STATUS.STATUS_INIT, '揀貨中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOVE_BOX_STATUS_TXT, LOVE_BOX_STATUS.STATUS_SENT, '已寄出'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_LOVE_BOX_STATUS_TXT, LOVE_BOX_STATUS.STATUS_RECEIVED, '已送達'), _LOVE_BOX_STATUS_TXT);

var RECYCLE_ID_ORDER_STATUS = {
  CREATED: 0,
  ON_TRIAL: 1,
  PAID: 2,
  EXPIRE: 3,
  SUSPENDED: 4,
  SUBSCRIPTION_CANCELED: 5
};

var RECYCLE_ID_ORDER_STATUS_TXT = (_RECYCLE_ID_ORDER_STA = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_ORDER_STA, RECYCLE_ID_ORDER_STATUS.CREATED, '未支付'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_ORDER_STA, RECYCLE_ID_ORDER_STATUS.ON_TRIAL, '試用中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_ORDER_STA, RECYCLE_ID_ORDER_STATUS.PAID, '已支付'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_ORDER_STA, RECYCLE_ID_ORDER_STATUS.EXPIRE, '已過期'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_ORDER_STA, RECYCLE_ID_ORDER_STATUS.SUSPENDED, '暫停中'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_ORDER_STA, RECYCLE_ID_ORDER_STATUS.SUBSCRIPTION_CANCELED, '取消訂閱'), _RECYCLE_ID_ORDER_STA);

var RECYCLE_ID_DISCOUNT_TYPE = {
  DISCOUNT_CODE: 0,
  INVITE_CODE: 1
};

var RECYCLE_ID_DISCOUNT_TYPE_TXT = (_RECYCLE_ID_DISCOUNT_ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_DISCOUNT_, RECYCLE_ID_DISCOUNT_TYPE.DISCOUNT_CODE, '折扣碼'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_DISCOUNT_, RECYCLE_ID_DISCOUNT_TYPE.INVITE_CODE, '公益邀請碼'), _RECYCLE_ID_DISCOUNT_);

var RECYCLE_ID_DISCOUNT_STATUS = {
  INVALID: 0,
  VALID: 1
};

var RECYCLE_ID_DISCOUNT_STATUS_TXT = (_RECYCLE_ID_DISCOUNT_2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_DISCOUNT_2, RECYCLE_ID_DISCOUNT_STATUS.INVALID, '無效'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_DISCOUNT_2, RECYCLE_ID_DISCOUNT_STATUS.VALID, '有效'), _RECYCLE_ID_DISCOUNT_2);

var RECYCLE_ID_DISCOUNT_RECORD_STATUS = {
  CREATED: 0,
  USED: 1
};

var RECYCLE_ID_DISCOUNT_RECORD_STATUS_TXT = (_RECYCLE_ID_DISCOUNT_3 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_DISCOUNT_3, RECYCLE_ID_DISCOUNT_RECORD_STATUS.CREATED, '試用中待使用'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_RECYCLE_ID_DISCOUNT_3, RECYCLE_ID_DISCOUNT_RECORD_STATUS.USED, '已使用'), _RECYCLE_ID_DISCOUNT_3);

/***/ }),

/***/ "CCWf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("5reh");


var _mutations;



var state = {
  pageInfo: {
    currentPage: 1
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* PRE_PAGE */], function (state) {
  --state.pageInfo.currentPage;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* NEXT_PAGE */], function (state) {
  ++state.pageInfo.currentPage;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ "Dfe3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{staticClass:"hd-wrapper"},[_c('span',[_vm._v("GC管理後台")]),_vm._v(" "),_c('div',{staticClass:"login-info"},[(_vm.userInfo)?_c('div',{staticClass:"user-info"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.smartImagePath(_vm.userInfo.avatar)}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.userInfo.nickname))])]):_vm._e(),_vm._v(" "),_c('el-button',{attrs:{"type":"danger","size":"small"},on:{"click":_vm.logout}},[_vm._v("\n        退出\n      ")])],1)]),_vm._v(" "),_c('el-container',[_c('el-aside',{attrs:{"width":"200px"}},[_c('el-col',{attrs:{"span":24}},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"router":"","default-active":"2","background-color":"#545c64","text-color":"#fff","active-text-color":"#ffd04b"},on:{"open":_vm.handleOpen,"close":_vm.handleClose}},_vm._l((_vm.asideNav),function(item){return (!item.children)?_c('el-menu-item',{key:item.name,attrs:{"index":item.path}},[(item.icon)?_c('i',{class:item.icon}):_vm._e(),_vm._v(" "),(item.iconAws)?_c('icon',{staticClass:"iconAws",attrs:{"name":item.iconAws}}):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.name))])],1):_c('el-submenu',{key:item.name,attrs:{"index":item.path}},[_c('template',{slot:"title"},[(item.icon)?_c('i',{class:item.icon}):_vm._e(),_vm._v(" "),(item.iconAws)?_c('icon',{staticClass:"iconAws",attrs:{"name":item.iconAws}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])],1),_vm._v(" "),_c('el-menu-item-group',_vm._l((item.children),function(child){return _c('el-menu-item',{key:child.name,attrs:{"index":child.path}},[_vm._v("\n                "+_vm._s(child.name)+"\n              ")])}),1)],2)}),1)],1)],1),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FlIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDateOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return smartImagePath; });
/**
 * Created by lxhfight on 2017/11/15.
 * Email: lxhfight1@gmail.com
 * Description:
 */

var isArray = function isArray(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]';
};

var getDate = function getDate(str) {
  var date = '';
  if (str) {
    date = new Date(str);
  } else {
    date = new Date();
  }
  var month = date.getMonth() + 1;
  var day = date.getDate();
  return date.getFullYear() + '-' + (month >= 10 ? month : '0' + month) + '-' + (day >= 10 ? day : '0' + day);
};

var getDateTime = function getDateTime(str) {
  var date = new Date(str);
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minite = date.getMinutes();
  var second = date.getSeconds();
  return date.getFullYear() + '-' + (month >= 10 ? month : '0' + month) + '-' + (day >= 10 ? day : '0' + day) + (' ' + (hour >= 10 ? hour : '0' + hour) + ':' + (minite >= 10 ? minite : '0' + minite) + ':' + (second >= 10 ? second : '0' + second));
};

var getDateOnly = function getDateOnly(str) {
  var date = new Date(str);
  var month = date.getMonth() + 1;
  var day = date.getDate();
  return (month >= 10 ? month : '0' + month) + '\u6708' + (day >= 10 ? day : '0' + day) + '\u65E5';
};
var smartImagePath = function smartImagePath(path) {
  var isSmall = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var original = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var imagePath = path;
  if (!imagePath) {
    return null;
  }
  var suffix = imagePath.substring(imagePath.lastIndexOf('.'));
  var type = isSmall ? '-small' : '-big';
  type = original ? '' : type;
  if (!imagePath.includes('s3-ap-southeast-1.amazonaws.com') && !imagePath.includes('api.give543.com') || imagePath.includes('zrockgive') || imagePath.includes('request') || imagePath.includes('/test/') || imagePath.includes('/avatar/') && type === '-big' || imagePath.includes('/chat/') && type === '-big' || suffix === '.gif') {
    return imagePath.replace('s3-ap-southeast-1.amazonaws.com/next.give543', 'd2hrw3sjxwwsb1.cloudfront.net');
  }
  var index = imagePath.lastIndexOf('.');
  imagePath = '' + imagePath.substring(0, index) + type + imagePath.substring(index);
  return imagePath.replace('s3-ap-southeast-1.amazonaws.com/next.give543', 'd2hrw3sjxwwsb1.cloudfront.net');
};

/***/ }),

/***/ "G/1F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserTags_vue__ = __webpack_require__("1gIA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7534b5a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserTags_vue__ = __webpack_require__("aWzF");
function injectStyle (ssrContext) {
  __webpack_require__("5Xbg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7534b5a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserTags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7534b5a5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserTags_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_login__ = __webpack_require__("jeSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_wishes__ = __webpack_require__("CCWf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_user__ = __webpack_require__("bREw");








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

// const debug = process.env.NODE_ENV !== 'production'

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  modules: {
    login: __WEBPACK_IMPORTED_MODULE_4__modules_login__["a" /* default */],
    wishes: __WEBPACK_IMPORTED_MODULE_5__modules_wishes__["a" /* default */],
    user: __WEBPACK_IMPORTED_MODULE_6__modules_user__["a" /* default */]
    // strict: debug,
    // plugins: debug ? [createLogger()] : []
  } }));

/***/ }),

/***/ "Jhyx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48122749_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Jhyx");
function injectStyle (ssrContext) {
  __webpack_require__("hJ1i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48122749_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_charts__ = __webpack_require__("vO7p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_charts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_v_charts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_fetch_js__ = __webpack_require__("Vo7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_constant__ = __webpack_require__("8e4C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome__ = __webpack_require__("JPH7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_awesome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UserTags__ = __webpack_require__("G/1F");

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_v_charts___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_10_vue_awesome___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('user-tags', __WEBPACK_IMPORTED_MODULE_11__components_UserTags__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_8__utils_fetch_js__["b" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$network = __WEBPACK_IMPORTED_MODULE_8__utils_fetch_js__["a" /* Network */];

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('permission', {
  inserted: function inserted(el, binding, vnode) {
    if (__WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.roles.includes('visitor')) {
      el.parentNode.removeChild(el);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('storyType', function (value) {
  if (!value) return '';
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["Y" /* storyTypes */]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var type = _step.value;

      if (type.id === value) {
        return type.title;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return '';
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('gender', function (value) {
  if (!value) return '';
  switch (value) {
    case 'MALE':
      return '男';
    case 'FEMALE':
      return '女';
    case 'OTHER':
      return '保密';
    default:
      return '保密';
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('genderColor', function (value) {
  if (!value) return '';
  switch (value) {
    case 'MALE':
      return 'color-blue';
    case 'FEMALE':
      return 'color-pink';
    case 'OTHER':
      return 'color-gray-deep';
    default:
      return 'color-gray-deep';
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('yesOrNo', function (value) {
  if (!value) return '';
  if (value === 'Y' || value === 1) {
    return '是';
  } else {
    return '否';
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('yesOrNoColor', function (value) {
  if (!value) return '';
  if (value === 'Y' || value === 1) {
    return 'color-green';
  } else {
    return 'color-orange';
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('incomes', function (value) {
  if (!value) return '-';
  var options = [{ text: '0-30萬', value: '0' }, { text: '30-60萬', value: '30' }, { text: '60-100萬', value: '60' }, { text: '100-200萬', value: '100' }, { text: '200萬以上', value: '200' }];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var option = _step2.value;

      if (option.value === value) {
        return option.text;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return '-';
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('role', function (value) {
  if (!value) return '-';
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["W" /* roleList */]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var role = _step3.value;

      if (value === role.id) {
        return role.label;
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return '';
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('itemStatus', function (value) {
  if (!value) return '-';
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["V" /* needStatus */]), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var role = _step4.value;

      if (value === role.value) {
        return role.label;
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  return '-';
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('itemStatusClass', function (value) {
  if (!value) return '-';
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["V" /* needStatus */]), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var role = _step5.value;

      if (value === role.value) {
        return role.className;
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return '-';
});
// 需求交易状态过滤器
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('needDealStatus', function (value) {
  if (!value) return '-';
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["T" /* needDealStatus */]), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var item = _step6.value;

      if (value === item.value) {
        return item.label;
      }
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return '-';
});
// GC代贈訂單索取状态过滤器
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('giftDealStatus', function (value) {
  if (!value) return '-';
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["M" /* giftDealStatus */]), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var item = _step7.value;

      if (value === item.value) {
        return item.label;
      }
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  return '-';
});
// 礼物索取状态过滤器
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('giftDealStatus', function (value) {
  if (!value) return '-';
  var _iteratorNormalCompletion8 = true;
  var _didIteratorError8 = false;
  var _iteratorError8 = undefined;

  try {
    for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["M" /* giftDealStatus */]), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
      var item = _step8.value;

      if (value === item.value) {
        return item.label;
      }
    }
  } catch (err) {
    _didIteratorError8 = true;
    _iteratorError8 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion8 && _iterator8.return) {
        _iterator8.return();
      }
    } finally {
      if (_didIteratorError8) {
        throw _iteratorError8;
      }
    }
  }

  return '-';
});

// EDM状态过滤器
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('edmStatus', function (value) {
  if (!value) return '-';
  var _iteratorNormalCompletion9 = true;
  var _didIteratorError9 = false;
  var _iteratorError9 = undefined;

  try {
    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["J" /* edmStatus */]), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
      var item = _step9.value;

      if (value === item.value) {
        return item.label;
      }
    }
  } catch (err) {
    _didIteratorError9 = true;
    _iteratorError9 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion9 && _iterator9.return) {
        _iterator9.return();
      }
    } finally {
      if (_didIteratorError9) {
        throw _iteratorError9;
      }
    }
  }

  return '-';
});

// 货运方式状态过滤器
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('shipway', function (value) {
  if (!value) return '-';
  var _iteratorNormalCompletion10 = true;
  var _didIteratorError10 = false;
  var _iteratorError10 = undefined;

  try {
    for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["U" /* needShipWays */]), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
      var item = _step10.value;

      if (value === item.value) {
        return item.label;
      }
    }
  } catch (err) {
    _didIteratorError10 = true;
    _iteratorError10 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion10 && _iterator10.return) {
        _iterator10.return();
      }
    } finally {
      if (_didIteratorError10) {
        throw _iteratorError10;
      }
    }
  }

  return '-';
});

// 物品分类状态过滤器
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('thingCategory', function (value) {
  if (!value) return '-';
  var _iteratorNormalCompletion11 = true;
  var _didIteratorError11 = false;
  var _iteratorError11 = undefined;

  try {
    for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["Z" /* thingCategory */]), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
      var item = _step11.value;

      if (value === item.value) {
        return item.label;
      }
    }
  } catch (err) {
    _didIteratorError11 = true;
    _iteratorError11 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion11 && _iterator11.return) {
        _iterator11.return();
      }
    } finally {
      if (_didIteratorError11) {
        throw _iteratorError11;
      }
    }
  }

  return '-';
});

// 交易状态过滤器
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('loveboxTradeStatus', function (value) {
  var _iteratorNormalCompletion12 = true;
  var _didIteratorError12 = false;
  var _iteratorError12 = undefined;

  try {
    for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["S" /* loveboxTradeStatuses */]), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
      var item = _step12.value;

      if (value === item.value) {
        return item.label;
      }
    }
  } catch (err) {
    _didIteratorError12 = true;
    _iteratorError12 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion12 && _iterator12.return) {
        _iterator12.return();
      }
    } finally {
      if (_didIteratorError12) {
        throw _iteratorError12;
      }
    }
  }

  return '-';
});

// 交易状态过滤器
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('loveboxItemStatus', function (value) {
  var _iteratorNormalCompletion13 = true;
  var _didIteratorError13 = false;
  var _iteratorError13 = undefined;

  try {
    for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["R" /* loveboxItemStatuses */]), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
      var item = _step13.value;

      if (value === item.value) {
        return item.label;
      }
    }
  } catch (err) {
    _didIteratorError13 = true;
    _iteratorError13 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion13 && _iterator13.return) {
        _iterator13.return();
      }
    } finally {
      if (_didIteratorError13) {
        throw _iteratorError13;
      }
    }
  }

  return '-';
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('feedbackStatus', function (value) {
  return __WEBPACK_IMPORTED_MODULE_9__utils_constant__["K" /* fbStatusList */].find(function (item) {
    return item.value === value;
  }).label;
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('notifyCategory', function (value) {
  switch (value) {
    case 'commonweal':
      return '公益團體';
    case 'care':
      return '關懷會員';
    case 'charitys':
      return '公益捐贈會員';
    case 'specified':
      return '指定會員';
    default:
      return '所有';
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('purchaseFromFilter', function (value) {
  var _iteratorNormalCompletion14 = true;
  var _didIteratorError14 = false;
  var _iteratorError14 = undefined;

  try {
    for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_9__utils_constant__["q" /* PURCHASE_FROM */]), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
      var item = _step14.value;

      if (value === item.value) {
        return item.label;
      }
    }
  } catch (err) {
    _didIteratorError14 = true;
    _iteratorError14 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion14 && _iterator14.return) {
        _iterator14.return();
      }
    } finally {
      if (_didIteratorError14) {
        throw _iteratorError14;
      }
    }
  }

  return '-';
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */] }
});

/***/ }),

/***/ "NnQf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, exports) {



/***/ }),

/***/ "Vo7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Network; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return queryString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__object__ = __webpack_require__("FlIN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__("bzuE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_js__);






var checkTokenValid = function checkTokenValid(response, cb) {
  if (response.status === 200) {
    if (response.data.code === 101 || response.data.code === 100) {
      window.location.href = '/login';
      return;
    }

    if (cb && typeof cb === 'function') {
      cb(response.data);
    } else {
      if (response.data && response.data.error) {
        throw new Error(response.data.error);
      }
    }

    return response.data;
  }
  throw new Error(response.statusText);
};

var fetch = function fetch(method, url) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$body = _ref.body,
      body = _ref$body === undefined ? {} : _ref$body,
      data = _ref.data,
      _ref$param = _ref.param,
      param = _ref$param === undefined ? {} : _ref$param;

  var cb = arguments[3];

  var token = localStorage.token;
  var isUpload = url.includes('upload');
  var contentType = isUpload ? 'multipart/form-data' : 'application/json';
  var headers = {
    'Content-Type': contentType,
    'Authorization': 'Bearer ' + token
  };
  if (method === 'get' || method === 'delete') {
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a[method](getUrl(url), {
      headers: headers
    }).then(function (res) {
      return checkTokenValid(res, cb);
    }).catch(function (err) {
      if (cb && typeof cb === 'function') {
        cb(null, err);
      } else {
        throw err;
      }
    });
  }

  body.param = param;

  if (data) {
    body.data = data;
  }
  if (isUpload) {
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a[method](getUrl(url), data, { headers: headers }).then(function (response) {
      return checkTokenValid(response, cb);
    }).catch(function (err) {
      if (cb && typeof cb === 'function') {
        cb(null, err);
      } else {
        throw err;
      }
    });
  } else {
    return __WEBPACK_IMPORTED_MODULE_2_axios___default.a[method](getUrl(url), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, body.data), { headers: headers }).then(function (response) {
      return checkTokenValid(response, cb);
    }).catch(function (err) {
      if (cb && typeof cb === 'function') {
        cb(null, err);
      } else {
        throw err;
      }
    });
  }
};

var Network = {
  get: function get(path, params) {
    var token = localStorage.token;
    var url = params ? '' + path + queryString(params) : path;
    var headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    };
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a['get'](getUrl(url), {
        headers: headers
      }).then(function (res) {
        return checkTokenValid(res, resolve);
      }).catch(function (err) {
        reject(err);
      });
    });
  }
};

var getUrl = function getUrl(url) {
  if (url.includes('upload')) {
    return __WEBPACK_IMPORTED_MODULE_4__config_js__["uploadUrl"];
  }

  if (url.startsWith('/v1/')) {
    return __WEBPACK_IMPORTED_MODULE_4__config_js___default.a.server + url;
  }

  if (url.startsWith('/api/') || url.startsWith('/test/')) {
    return __WEBPACK_IMPORTED_MODULE_4__config_js___default.a.server + url;
  }
  return __WEBPACK_IMPORTED_MODULE_4__config_js___default.a.server + __WEBPACK_IMPORTED_MODULE_4__config_js___default.a.reqlApi + url;
};

var queryString = function queryString(obj) {
  if (!obj) {
    return null;
  }
  var result = '';
  for (var param in obj) {
    var content = '';
    if (!obj[param] && obj[param] !== 0) {
      continue;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_3__object__["d" /* isArray */])(obj[param])) {
      if (obj[param].length === 0) {
        continue;
      }
      content = obj[param].toString();
    } else {
      content = obj[param];
    }
    result += result ? '&' + param + '=' + content : '?' + param + '=' + content;
  }
  return result;
};

/* harmony default export */ __webpack_exports__["b"] = (fetch);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_HelloWorld__ = __webpack_require__("gORT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__("IcnI");






__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var staticRoutes = [{
  path: '/login',
  name: 'Login',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(96).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DZ/+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '',
  name: 'Hello',
  component: __WEBPACK_IMPORTED_MODULE_3__components_HelloWorld__["a" /* default */]
}];

var asyncRoutes = [{
  path: '/',
  name: 'Root',
  component: __WEBPACK_IMPORTED_MODULE_3__components_HelloWorld__["a" /* default */],
  children: [{
    path: 'home',
    name: 'Home',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RV/S")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: 'wishMg',
    name: 'WishMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NfMI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: 'readingMg',
    name: 'readingMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("W6FP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/wishConfig',
    name: 'WishConfigMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RAve")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/newWish',
    name: 'NewWish',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lNfB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['esg.admin']
    }
  }, {
    path: '/wishedit/:id',
    name: 'WishEdit',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lNfB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['esg.admin']
    }
  }, {
    path: '/realnameMg',
    name: 'RealNameMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gDAx")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/realname/:id',
    name: 'realnamePage',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(92).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SYML")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: []
    }
  }, {
    path: '/changeRoleMg',
    name: 'ChangeRoleMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("B4Hz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/changerole/:id',
    name: 'ChangeRolePage',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kVrx")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: []
    }
  }, {
    path: '/bannerMg',
    name: 'BannerMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0lep")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor', 'esg.admin']
    }
  }, {
    path: '/stories',
    name: 'StoryMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eEU6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor', 'esg.admin']
    }
  }, {
    path: '/story/:id',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(95).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("s8nV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor', 'esg.admin']
    },
    children: [{
      path: 'details',
      name: 'StoryPage',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NeNM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        roles: ['visitor', 'editor', 'esg.admin']
      }
    }, {
      path: 'comments',
      name: 'StoryPageComments',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(93).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HWv8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      meta: {
        roles: ['visitor', 'editor', 'esg.admin']
      }
    }]
  }, {
    path: '/newStory',
    name: 'NewStory',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NeNM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['editor', 'esg.admin']
    }
  }, {
    path: '/users',
    name: 'users',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hMWQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/users/:id',
    name: 'user',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("V9W7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/userLogins',
    name: 'userLogins',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Mox+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/userbonus',
    name: 'userbonus',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ob6S")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/multipleAccounts',
    name: 'multipleAccounts',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("f9yA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/needsListMg',
    name: 'NeedsListMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FfUc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/reportedNeeds',
    name: 'ReportedNeedMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MlRq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/needItem/:id',
    name: 'NeedItemPage',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TGb0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/needsRecords',
    name: 'NeedsRecord',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mlJB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/needsSections',
    name: 'NeedsSectionsMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("W4Bm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/needRecord/:id',
    name: 'NeedRecord',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GR8F")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/gifts',
    name: 'GiftMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("f/Ll")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/reportedGifts',
    name: 'ReportedGiftMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Q08K")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/gift/:id',
    name: 'GiftPage',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XP2P")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/giftRecords',
    name: 'GiftRecordMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("F8ps")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/giftRecord/:id',
    name: 'GiftRecordPage',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pILC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/changeLogMg',
    name: 'ChangeLogMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jvga")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['']
    }
  }, {
    path: '/feedBackMg',
    name: 'FeedBackMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ul8g")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/feedback/:id',
    name: 'FeedBackPage',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xjyr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/edmMg',
    name: 'EDMMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uf6X")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor']
    }
  }, {
    path: '/edm/new',
    name: 'EDMNew',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DOqj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['editor']
    }
  }, {
    path: '/edm/:id',
    name: 'EDMDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DOqj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor']
    }
  }, {
    path: '/notifyMg',
    name: 'NotifyMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ixcs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor', 'love.admin']
    }
  }, {
    path: '/lovebox/courseNotifyMg',
    name: 'LoveboxCourseNotifyMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("luby")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/lovebox/companies-apply',
    name: 'LoveBoxApplyCompanies',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZwWp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/lovebox/companies',
    name: 'LoveBoxCompanies',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iFSy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/lovebox/objects',
    name: 'LoveBoxObjects',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qweg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/lovebox/objects/:id',
    name: 'LoveBoxObjectsDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("qDGf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/lovebox/trades',
    name: 'LoveBoxTrades',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pBLv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/lovebox/trades/:id',
    name: 'LoveBoxTradeDetail',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SVdz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/lovebox/application',
    name: 'LoveBoxApplication',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dqqF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, { // GC代贈寄送記錄路由
    path: '/lovebox/dispatching',
    name: 'LoveBoxDispatching',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yVRu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/lovebox/whitelist',
    name: 'LoveBoxWhiteList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("l16V")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/employees/:id',
    name: 'employees',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0qA3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/preEvents',
    name: 'preEvents',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("N8Eg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor']
    }
  }, {
    path: '/preEvent/:id',
    name: 'preEvent',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HOxS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/exportpalmboxcsv',
    name: 'exportPalmBoxCSV',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gP8a")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: []
    }
  }, {
    path: '/newconnect',
    name: 'newConnect',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(94).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nRYO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/cabinetGiftMg',
    name: 'cabinetGiftMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(100).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dI02")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/cabinetGift/:id',
    name: 'cabinetGiftPage',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(99).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("t1Wf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/reportedMoments',
    name: 'ReportedMomentsMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("MFk0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/applyCancelDeals',
    name: 'ApplyCancelDealsMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Yz0C")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/momentsListMg',
    name: 'MomentsListMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(85).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gS/R")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor']
    }
  }, {
    path: '/agreementConfig',
    name: 'AgreementConfig',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(90).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VSIW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor']
    }
  }, {
    path: '/carbonAccountAgreementConfig',
    name: 'AgreementConfig',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(89).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ykyg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor']
    }
  }, {
    path: '/privacyConfig',
    name: 'PrivacyConfig',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(88).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ep5/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor']
    }
  }, {
    path: '/about543Config',
    name: 'About543Config',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(91).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sRnI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'editor']
    }
  }, {
    path: '/regardItem/list',
    name: 'RegardItemList',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Mh8m")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/regardItem/sponsors',
    name: 'RegardItemSponsors',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IW19")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/regardItem/greetings',
    name: 'RegardItemGreetings',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KhiM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/paymentOrders',
    name: 'PaymentOrders',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KvA8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/paymentStatistics',
    name: 'PaymentStatistics',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9J9H")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/walletRecords',
    name: 'WalletRecords',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("give")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/walletRecordsStatistics',
    name: 'WalletRecordsStatistics',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DtUv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/walletUserStatistics',
    name: 'WalletUserStatistics',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Bi1e")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/iboxOrders',
    name: 'IBoxStatistics',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tYA0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/hilifeOrders',
    name: 'IBoxStatistics',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oKYe")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/sevenElevenOrders',
    name: 'SevenElevenOrders',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BtrC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/hctOrders',
    name: 'HCTOrders',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+ota")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/refunds',
    name: 'WalletRefunds',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Q+kK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/userMarks',
    name: 'UserMarksMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Fzb5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/organizers',
    name: 'OrganizersMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("agDQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/organizers/users',
    name: 'OrganizerUsersMg',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(97).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ih/Y")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/expresses',
    name: 'Expresses',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tEZU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/coupons',
    name: 'WalletCoupons',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("izev")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/wallet/couponRecords',
    name: 'WalletCouponRecords',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ua+i")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor']
    }
  }, {
    path: '/settings',
    name: 'Settings',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("tjkV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/carbonlabelling/organizers',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NGE9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbonlabelling/groups',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IyQx")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbonlabelling/users',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(98).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("meVL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbonlabelling/courses',
    name: 'admin.courses',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JLdp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbonlabelling/courses/new',
    name: 'admin.courses.create',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("a+Ps")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbonlabelling/courses/:id',
    name: 'admin.courses.edit',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("a+Ps")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbonlabelling/subscriptions',
    name: 'admin.subscriptions',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7Xtq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbonlabelling/course-results',
    name: 'admin.courseResults',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("83Lj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbonlabelling/report/:id',
    name: 'CarbonLabellingReport',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Cyv8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/welfare/enterprises',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FKOy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/giftRatings',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Rkiy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/lovebox/company-report/:id',
    name: 'LoveboxCompanyReport',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5WSw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'love.admin', 'esg.admin']
    }
  }, {
    path: '/companyPages',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("cVlg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbon-account/products',
    name: 'CarbonAccountProducts',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3HBc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbon-account/orders',
    name: 'CarbonAccountOrders',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uXA8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbon-account/discounts',
    name: 'CarbonAccountDiscounts',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9VeC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbon-account/discount-records',
    name: 'CarbonAccountDiscountRecords',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jS70")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/carbon-account/contacts',
    name: 'CarbonAccountContacts',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("td/t")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    meta: {
      roles: ['visitor', 'esg.admin']
    }
  }, {
    path: '/',
    name: ''
  }]
}, {
  path: '/carbonLabelling/:id/thanks',
  name: 'CarbonLabellingThanks',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lAjn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: ['visitor', 'esg.admin']
  }
}, {
  path: '/lovebox/company-report/:id/thanks',
  name: 'LoveboxCompanyThanks',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("CJgt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  meta: {
    roles: ['visitor', 'love.admin', 'esg.admin']
  }
}, {
  path: '*',
  name: '_404Page',
  component: function component(resolve) {
    return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Avp6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: staticRoutes
});

var hasPermission = function hasPermission(roles, route) {
  if (route && route.meta && route.meta.roles) {
    return roles.some(function (role) {
      return route.meta.roles.indexOf(role) >= 0;
    });
  } else {
    return true;
  }
};

var matchRoutes = function matchRoutes(roles) {
  var accessRoutes = asyncRoutes.filter(function (route) {
    if (roles.includes('admin')) {
      return true;
    }

    if (hasPermission(roles, route)) {
      if (route.children && route.children.length > 0) {
        route.children = route.children.filter(function (child) {
          if (roles.includes('admin')) {
            return true;
          }

          if (hasPermission(roles, child)) {
            return true;
          }

          return false;
        });
      }

      return true;
    }

    return false;
  });

  return accessRoutes;
};

router.beforeEach(function (to, from, next) {
  if (to.path === '/login') {
    next();
    return;
  }
  var token = localStorage.getItem('token');
  if (token) {
    if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.roles.length === 0) {
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('getUserInfo').then(function (res) {
        var roles = res.data.roles;
        router.addRoutes(matchRoutes(roles));
        if (to.path === '/') {
          if (roles.some(function (role) {
            return ['admin', 'visitor', 'esg.admin'].indexOf(role) >= 0;
          })) {
            next({ path: '/home', replace: true });
          } else if (roles.includes('editor')) {
            next({ path: '/stories', replace: true });
          } else if (roles.includes('love.admin')) {
            next({ path: '/lovebox/trades', replace: true });
          } else {
            next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to, { replace: true }));
          }
        } else {
          next(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, to, { replace: true }));
        }
      }).catch(function (err) {
        console.log(err);
        next({ path: '/login' });
      });
    } else {
      next();
    }
  } else if (to.path === '/login') {
    next();
  } else {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "aWzF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTags.length)?_c('span',{staticClass:"user-tags"},_vm._l((_vm.showTags),function(tag){return _c('span',{key:tag.key,class:['tag-badge', tag.className],attrs:{"title":tag.label}},[_vm._v(_vm._s(tag.text))])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_fetch_js__ = __webpack_require__("Vo7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__("5reh");




var state = {
  userInfo: null
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
  setUserInfo: function setUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  }
}, __WEBPACK_IMPORTED_MODULE_2__types__["b" /* LOGOUT */], function (state) {
  state.userInfo = null;
});

var actions = {
  getUserInfo: function getUserInfo(_ref) {
    var commit = _ref.commit;

    return Object(__WEBPACK_IMPORTED_MODULE_1__utils_fetch_js__["b" /* default */])('get', '/my/info').then(function (res) {
      commit('setUserInfo', res.data);
      return res;
    });
  }
};

var getters = {
  roles: function roles(state) {
    return state.userInfo ? state.userInfo.roles : [];
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});

/***/ }),

/***/ "bzuE":
/***/ (function(module, exports) {

var href = window.location.href;

if (href.indexOf('qa-mgr.give543.com') !== -1) {
  module.exports = {
    server: '//qa-api.give543.com',
    reqlApi: '/api/admin',
    frontEndUrl: 'https://qa.give543.com',
    uploadUrl: 'https://qa-api.give543.com/api/file/uploadImg',
    wmsUploadUrl: 'https://qa-api.give543.com/api/wms/file/uploadImage',
    host: '//qa-api.give543.com',
    mobileUrl: 'https://m.qa.give543.com',
    organizerMobileUrl: 'https://morg.qa.give543.com',
    hilifeUrl: 'https://ecservicedev.hilife.com.tw/ecapi/v1/ec_ordersprn_C2C.aspx?ParentId=136&EshopId=021&OrderNo='
  };
} else if (href.indexOf('give-circle.com') !== -1) {
  module.exports = {
    server: '//api.give543.com',
    reqlApi: '/api/admin',
    uploadUrl: '//api.give543.com/api/file/uploadImage',
    host: '//api.give543.com/',
    frontEndUrl: '//www.give-circle.com',
    mobileUrl: '//m.give-circle.com',
    hilifeUrl: 'https://ecservice.hilife.com.tw/ecapi/v1/ec_ordersprn_C2C.aspx?ParentId=136&EshopId=021&OrderNo='
  };
} else if (href.indexOf('give543.com') !== -1) {
  module.exports = {
    server: '//api.give543.com',
    reqlApi: '/api/admin',
    uploadUrl: '//api.give543.com/api/file/uploadImage',
    wmsUploadUrl: '//api.give543.com/api/wms/file/uploadImage',
    host: '//api.give543.com/',
    frontEndUrl: 'https://www.give-circle.com',
    mobileUrl: 'https://m.give-circle.com',
    organizerMobileUrl: 'https://m.org.give-circle.com',
    hilifeUrl: 'https://ecservice.hilife.com.tw/ecapi/v1/ec_ordersprn_C2C.aspx?ParentId=136&EshopId=021&OrderNo='
  };
} else {
  module.exports = {
    server: 'https://qa-api.give543.com',
    reqlApi: '/api/admin',
    frontEndUrl: 'https://qa.give543.com',
    uploadUrl: 'https://qa-api.give543.com/api/file/uploadImg',
    wmsUploadUrl: 'https://qa-api.give543.com/api/wms/file/uploadImage',
    host: '//qa-api.give543.com',
    mobileUrl: 'https://m.qa.give543.com',
    organizerMobileUrl: 'https://morg.qa.give543.com',
    hilifeUrl: 'https://ecservicedev.hilife.com.tw/ecapi/v1/ec_ordersprn_C2C.aspx?ParentId=136&EshopId=021&OrderNo='
  };
}

/***/ }),

/***/ "gORT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__ = __webpack_require__("07PK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a08d31a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__ = __webpack_require__("Dfe3");
function injectStyle (ssrContext) {
  __webpack_require__("NnQf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a08d31a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelloWorld_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a08d31a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelloWorld_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hJ1i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jeSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("5reh");


var _mutations;



var state = {
  loginInfo: {
    token: ''
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* LOGIN */], function (state, _ref) {
  var token = _ref.token;

  state.loginInfo.token = token;
  window.localStorage.setItem('token', token);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* LOGOUT */], function (state) {
  state.loginInfo.token = '';
  window.localStorage.removeItem('token');
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),

/***/ "mUbh":
/***/ (function(module, exports) {



/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    if (window.localStorage.getItem('token') === 'give543jwt') {
      this.$store.commit('LOGOUT');
      this.$router.push('/login');
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.841d06a7b5d336ef6093.js